import { render, staticRenderFns } from "./SlipModal.vue?vue&type=template&id=f17c91b4"
import script from "./SlipModal.vue?vue&type=script&lang=js"
export * from "./SlipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports